export default "__VITE_ASSET__3d8b51be__"